export default "__VITE_ASSET__CzXdG_CU__"